import { Badge } from '@shared/ui/badge/Badge';
import { RECEIPT_STATUS_LABELS } from '../types';
import type { ReceiptStatus } from '../types';

const toneByStatus: Record<ReceiptStatus, 'success' | 'warning'> = {
  validated: 'success',
  needs_review: 'warning',
};

export interface ReceiptStatusBadgeProps {
  status: ReceiptStatus | undefined;
}

/**
 * Pastille de statut dérivée du niveau de confiance à la validation :
 * « Validé » (confiance élevée) ou « À revoir ».
 */
export function ReceiptStatusBadge({ status }: ReceiptStatusBadgeProps) {
  return (
    <Badge tone={status ? toneByStatus[status] : 'warning'}>
      {status ? RECEIPT_STATUS_LABELS[status] : 'Inconnu'}
    </Badge>
  );
}
